"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Avatar = require("../Avatar");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _Link = require("../Link");

var _Text = require("../Text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Component that is used as entity header that is paired with rich information about the entity.
 * Spec: zpl.io/aNoYM6d
 */
var EntityHeader = function EntityHeader(_ref) {
  var href = _ref.href,
      imageUrl = _ref.imageUrl,
      initials = _ref.initials,
      name = _ref.name,
      meta = _ref.meta,
      FollowButton = _ref.FollowButton,
      smallVariant = _ref.smallVariant,
      remainderProps = _objectWithoutProperties(_ref, ["href", "imageUrl", "initials", "name", "meta", "FollowButton", "smallVariant"]);

  var ContainerComponent = href ? FlexLink : _Flex.Flex;
  var containerProps = href ? {
    color: "black100",
    noUnderline: true,
    href: href
  } : {};
  return /*#__PURE__*/_react.default.createElement(ContainerComponent, _extends({}, remainderProps, containerProps), (imageUrl || initials) && /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_Avatar.Avatar, {
    size: smallVariant ? "xxs" : "xs",
    src: imageUrl,
    initials: initials
  })), smallVariant ? /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text"
  }, name), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text"
  }, FollowButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text",
    mx: 0.3,
    display: "inline-block"
  }, "\u2022"), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    display: "inline-block",
    onClick: function onClick(event) {
      // Capture click event so that interacting with Follow doesn't
      // trigger Container's link.
      event.stopPropagation();
    }
  }, FollowButton)))) : /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "mediumText",
    color: "black100"
  }, name), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text",
    color: "black60"
  }, !!meta && /*#__PURE__*/_react.default.createElement("span", null, meta), FollowButton && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, meta && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "text",
    color: "black60",
    mx: 0.3,
    display: "inline-block"
  }, "\u2022"), /*#__PURE__*/_react.default.createElement(_Box.Box, {
    display: "inline-block",
    onClick: function onClick(event) {
      // Capture click event so that interacting with Follow doesn't
      // trigger Container's link.
      event.stopPropagation();
    }
  }, FollowButton)))));
};

exports.EntityHeader = EntityHeader;
EntityHeader.displayName = "EntityHeader";
var FlexLink = (0, _styledComponents.default)(_Link.Link).withConfig({
  displayName: "EntityHeader__FlexLink",
  componentId: "sc-12y32bx-0"
})(["display:flex;"]);
EntityHeader.displayName = "EntityHeader";
//# sourceMappingURL=EntityHeader.js.map